module.exports = __webpack_public_path__ + "static/media/vidyard-logo-text.d7932cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/vidyard-logo-text.png
// module id = Rjoa
// module chunks = 89